import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import ReactPlayer from 'react-player';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import { Browser } from '@capacitor/browser';
import NativeOrWeb from '../../utils/native';
import { getYouTubeVideoIdFromUrl } from '../../utils/url';
import './VideoPlayer.scss';

class VideoPlayer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { loaded: false };
  }

  getPlayer = () => this.player;
  handleReady = player => {
    this.player = player; // Store a player that is ready for methods
    this.setState({ loaded: true });
  };

  getThumbnailUrl = () => {
    const { url, thumbnail } = this.props;

    if (thumbnail) {
      return thumbnail;
    }

    if (url) {
      const youtubeId = getYouTubeVideoIdFromUrl(url);
      if (youtubeId) {
        return `https://img.youtube.com/vi/${youtubeId}/mqdefault.jpg`;
      }
    }

    return null;
  };

  handleThumbnailClick = async () => {
    const { url } = this.props;
    if (url) {
      if (NativeOrWeb.isNativePlatform()) {
        await Browser.open({ url });
      } else {
        window.open(url, '_blank');
      }
    }
  };

  render() {
    const { className, style, containerProps, ...rest } = this.props;
    const { loaded } = this.state;
    const thumbnailUrl = this.getThumbnailUrl();

    const showThumbnail = NativeOrWeb.isIOSPlatform() && window.self === window.top;

    return (
      <div className="video-player" {...containerProps}>
        {!showThumbnail && !loaded && <Skeleton variant="rectangular" width="100%" height="100%" />}
        {showThumbnail ? (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }}
          >
            <div
              className="video-thumbnail-image"
              onClick={this.handleThumbnailClick}
              style={{
                width: '100%',
                height: '100%',
                backgroundImage: thumbnailUrl ? `url(${thumbnailUrl})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                cursor: 'pointer',
                borderRadius: '8px',
                backgroundColor: '#f0f0f0',
                position: 'relative'
              }}
            >
              <div
                className="video-thumbnail-text"
                onClick={this.handleThumbnailClick}
                style={{
                  position: 'absolute',
                  bottom: '16px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: 'rgba(255, 255, 255, 0.98)',
                  color: '#3966f8',
                  padding: '8px 16px',
                  textAlign: 'center',
                  fontSize: '18px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  borderRadius: '4px',
                  whiteSpace: 'nowrap',
                  textDecoration: "underline",
                  zIndex: 1
                }}
              >
                {this.props.intl.formatMessage({ id: 'click-to-open-video' })}
              </div>
            </div>
          </div>
        ) : (
          <ReactPlayer
            style={_.merge(
              {
                visibility: loaded ? 'visible' : 'hidden',
                position: loaded ? 'absolute' : 'fixed'
              },
              style
            )}
            onReady={this.handleReady}
            className="react-player"
            width="100%"
            height="100%"
            config={{
              youtube: {
                playerVars: {
                  controls: 1,
                  showinfo: 1,
                  enablejsapi: 1,
                  origin: 'https://www.youtube.com'
                  // origin: window.location.href,
                  // widget_referrer: window.location.href,
                  // host: `${window.location.protocol}//www.youtube.com`
                }
              }
            }}
            {...rest}
          />
        )}
      </div>
    );
  }
}

export default injectIntl(VideoPlayer);
